import DefaultValidation from '@/services/validations/DefaultValidation';

export default class CulturaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (!model.idtipoculturaerp) {
            refs.idculturaerpInput.focusedOut = true;
            validated = false;
        }

        if (!model.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}